import {
  formatShortWeekday,
  getCurrentDayPromos,
  getOffsetDay,
} from './utils.js';
import React, { useState } from 'react';
import DatePicker from 'react-date-picker';
import { CalendarIcon, NextIcon, PrevIcon } from './icons.mjs';
import NoPromos from './NoPromos.mjs';
import RowCards from './RowCards.mjs';

export default function RowCardsLayout({ propertyUrl, currentMonthObj, minValue, maxValue, mappedCalendarDays, rowCardHtag }) {
  const minString = minValue.toDateString();
  const minOffsetString = getOffsetDay(minValue, 1).toDateString();
  const maxString = maxValue.toDateString();
  const maxOffsetString = getOffsetDay(maxValue, -1).toDateString();
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(false);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(false);

  const [value, setValue] = useState(currentMonthObj.date);

  const disablePrevBtnHandler = (currentValueString) => {
    if (currentValueString === minString) {
      setPrevBtnDisabled(true);
    } else {
      if (currentValueString === minOffsetString) {
        setPrevBtnDisabled(true);
      } else {
        setPrevBtnDisabled(false);
      }
    }
  };

  const disableNextBtnHandler = (currentValueString) => {
    if (currentValueString === maxString) {
      setNextBtnDisabled(true);
    } else {
      if (currentValueString === maxOffsetString) {
        setNextBtnDisabled(true);
      } else {
        setNextBtnDisabled(false);
      }
    }
  };

  const onDateChangeHandler = (newValue) => {
    disablePrevBtnHandler(getOffsetDay(newValue, 1).toDateString());
    disableNextBtnHandler(getOffsetDay(newValue, -1).toDateString());

    setValue(newValue);
  };

  const onButtonClickDayChangeHandler = (buttonType) => {
    const currentValueString = value.toDateString();

    switch (buttonType) {
      case 'prev':
        disablePrevBtnHandler(currentValueString);

        if (currentValueString !== minString) {
          setValue(getOffsetDay(value, -1));
          setNextBtnDisabled(false);
        }
        break;
      case 'next':
        disableNextBtnHandler(currentValueString);

        if (currentValueString !== maxString) {
          setValue(getOffsetDay(value, 1));
          setPrevBtnDisabled(false);
        }
        break;
      default:
        console.log(`This button type: ${buttonType} is not handled for.`);
    }
  };

  if (mappedCalendarDays && mappedCalendarDays.length > 0) {
    return (
      <section className="row-cards-layout">
        <div className="d-flex flex-wrap justify-content-center justify-content-sm-between gap-3 mb-4">
          <DatePicker
            id="row-cards-layout-date-picker"
            onChange={onDateChangeHandler}
            value={value}
            clearIcon={null}
            format={'MM/dd/yyyy'}
            minDate={minValue}
            maxDate={maxValue}
            minDetail={'month'}
            maxDetail={'month'}
            calendarType={'gregory'}
            calendarIcon={<CalendarIcon />}
            formatShortWeekday={formatShortWeekday}
            next2Label={null}
            prev2Label={null}
            nextLabel={<NextIcon />}
            prevLabel={<PrevIcon />}
            calendarAriaLabel="Toggle calendar selection"
            monthAriaLabel="Input month"
            dayAriaLabel="Input day"
            yearAriaLabel="Input year"
            nativeInputAriaLabel="Date"
            nextAriaLabel="Next month"
            prevAriaLabel="Previous month"
          />

          <div className="d-flex gap-1">
            <button
              type="button"
              className="btn btn-subtle btn-subtle-primary btn-icon btn-sm"
              aria-label="Button to reset the day to today"
              onClick={() => { setValue(currentMonthObj.date); }}
            >
              <span className="material-icons">today</span>
              Today
            </button>

            <div className="d-flex">
              <button
                type="button"
                title="Button to go back one day"
                aria-label="Button to go back one day"
                className="btn-prev-day btn btn-subtle btn-subtle-primary btn-icon btn-sm"
                disabled={prevBtnDisabled}
                onClick={() => { onButtonClickDayChangeHandler('prev'); }}
              >
                <span className="material-icons">arrow_back</span>
              </button>

              <button
                type="button"
                title="Button to go forward one day"
                aria-label="Button to go forward one day"
                className="btn-next-day btn btn-subtle btn-subtle-primary btn-icon btn-sm"
                disabled={nextBtnDisabled}
                onClick={() => { onButtonClickDayChangeHandler('next'); }}
              >
                <span className="material-icons">arrow_forward</span>
              </button>
            </div>
          </div>
        </div>

        <RowCards
          promos={getCurrentDayPromos(mappedCalendarDays, value)}
          rowCardHtag={rowCardHtag}
        />

        <div className="row-cards-layout__link text-center mt-3">
          <a
            href={propertyUrl + '/promotions'}
            title="Promotions Calendar"
            className="btn btn-link"
          >
            Promotions Calendar
            <span className="material-icons">arrow_forward</span>
          </a>
        </div>
      </section>
    );
  } else {
    return <NoPromos />;
  }
}
